var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import id from "@irati/utils/id";
import sentry from "@irati/utils/services/sentry";
import { getErrorMessage } from "@irati/utils/lang/formatError";
import DefaultLoader from "./Loader";
import DefaultError from "./Error";
var Loading = /** @class */ (function (_super) {
    __extends(Loading, _super);
    function Loading(props) {
        var _this = _super.call(this, props) || this;
        _this.load = function (load) {
            var loaded = true;
            if (load && _this.isLoaded(load)) {
                loaded = false;
                load
                    .then(function () {
                    // only update state if this is the current promise in props
                    var isCurrent = load === _this.props.load;
                    if (isCurrent && _this.__isMounted) {
                        _this.setState({ loaded: true, errorMsg: null });
                    }
                })
                    .catch(function (error) {
                    /** Helper for devs to find the root issue easier. Throw is sentry too. */
                    console.error(error);
                    if (error && error.name === "TypeError") {
                        console.error(error);
                        sentry.captureException(error);
                    }
                    if (_this.__isMounted) {
                        _this.setState({ loaded: false, errorMsg: getErrorMessage(error), error: error });
                    }
                });
            }
            return loaded;
        };
        var loaded = _this.load(props.load);
        _this.state = { loaded: loaded, errorMsg: null };
        _this.__isMounted = true;
        return _this;
    }
    Loading.prototype.componentWillUnmount = function () {
        this.__isMounted = false;
    };
    Loading.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        if (nextProps.load !== this.props.load) {
            var loaded = this.load(nextProps.load);
            this.setState({ loaded: loaded, errorMsg: null });
        }
    };
    Loading.prototype.isLoaded = function (promise) {
        var isPromise = promise && "then" in promise;
        // other checks?
        return isPromise;
    };
    Loading.prototype.render = function () {
        var _a = this.state, loaded = _a.loaded, errorMsg = _a.errorMsg, error = _a.error;
        var _b = this.props, children = _b.children, Error = _b.Error, useLoader = _b.useLoader, Loader = _b.Loader;
        var idNamespace = id("loading", this.props);
        if (errorMsg) {
            return (React.createElement(Error, { id: id("copy-error", idNamespace), className: "perkboxLoading_error", errorMsg: errorMsg, error: error }, children));
        }
        if (!loaded && useLoader) {
            return React.createElement(Loader, { id: id("loader", idNamespace) }, children);
        }
        return React.createElement("div", { id: idNamespace }, children);
    };
    Loading.defaultProps = {
        load: null,
        Error: DefaultError,
        Loader: DefaultLoader,
        useLoader: true
    };
    return Loading;
}(Component));
export default Loading;
